import MenuIcon from '@mui/icons-material/Menu';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toTitleCase } from './CommonComponents';
import './styles/Header.css';
const AnimatedMenuIcon = motion(MenuIcon);

interface MenuItemProps {
    name: string;
    link?: string;
    level: number;
    children?: MenuItemProps[];
}

interface MenuProps {
    items: MenuItemProps[];
}

const MenuItemComponent = ({ item }: { item: MenuItemProps }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLLIElement>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [isHovered, setIsHovered] = useState(false);

    const handleNavigation = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        if (item.link) {
            navigate(item.link);
        }
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <>
            <li ref={menuRef}
                onClick={handleNavigation}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={item.level === 2 && item.link !== "" && isHovered ? {
                    backgroundColor: '#007066',
                    cursor: 'pointer',
                    width: '-webkit-fill-available',
                } : {
                    width: '-webkit-fill-available'
                }}
            >
                <span
                    style={{
                        ...(item.level === 2
                            ? {
                                padding: '0px',
                                textAlign: 'left',
                                fontWeight: '400',
                                fontSize: '16px',
                                fontFamily: 'Barlow',
                                lineHeight: '26px',
                            } : item.level === 1
                                ? {
                                    textTransform: 'uppercase',
                                    textAlign: 'left',
                                    fontFamily: 'Barlow Semi Condensed !important',
                                    lineHeight: '26px',
                                    fontWeight: '800',
                                    paddingLeft: '20px',
                                }
                                : {
                                    textTransform: 'uppercase',
                                    textAlign: 'left',
                                    fontFamily: 'Barlow',
                                    lineHeight: '26px',
                                    paddingLeft: '0px',
                                    paddingRight: '0px',
                                }),
                        cursor: 'pointer',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {item.level !== 2 ? item.name : toTitleCase(item.name)}
                </span>
                {
                    item.children?.length > 0 && (
                        <ul
                            style={item.level !== 0 ? {
                                top: '0%',
                                position: 'relative',
                                height: '200px',
                                alignItems: 'center',
                                overflowY: 'auto',
                                minWidth: '167px',
                                width: item.level == 1 ? '100%' : 'fit-content',
                                whiteSpace: 'nowrap',
                                marginLeft: item.level === 2 ? '5px' : '2px',
                            } : {
                                maxWidth: item.level === 0 ? '1000px' : 'unset',
                                overflowX: item.level === 0 ? 'auto' : 'visible',
                            }}> 
                            {item.children.map((subItem, index) => (
                                <MenuItemComponent key={index} item={subItem} />
                            ))}
                        </ul>
                    )
                }
            </li>
        </>
    );
};

const HeaderMenu = ({ items }: MenuProps) => {

    return (
        <ul className="menu">
            {items.map((item, index) => (
                <MenuItemComponent key={index} item={item} />
            ))}
        </ul>
    );
};


export default HeaderMenu;
